import { cloneElement } from 'react';
import { getNewItems } from "../../utils";
export var FaqHOC = function FaqHOC(props) {
  var categories = props.categories,
    children = props.children,
    onClick = props.onClick,
    title = props.title;
  return /*#__PURE__*/cloneElement(children, {
    categories: categories,
    items: getNewItems(props),
    onClick: onClick,
    title: title
  });
};